/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Balance
 */
export interface BalanceDto {
  asset: string;
  /**
   * Asset ref price for 1 unit
   */
  assetRefPrice: number;
  total: number;
  free: number;
  credit: number;
  fireblocksEnabled: boolean;
}
